var exports = {
  "ft": "xfd349460--3a00a1--comparison-banner",
  "DD": "xfd349460--3a00a1--title",
  "Sl": "xfd349460--3a00a1--image",
};

module.exports = exports;
